module.exports = __webpack_public_path__ + "static/img/sm.a3e58a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/sm.png
// module id = UI7n
// module chunks = 1